export default {"src":"/_next/static/media/flag-rus.6b79ea0e.svg","height":10,"width":10,"blurWidth":0,"blurHeight":0};